import React, { useEffect, useRef, useState } from 'react'
import { ContenedorParametros } from '../../../components/utils/ContenedorParametros'
import { useMatrizOperativa } from '../../../../hooks/gestionOperacional/useMatrizOperativa'
import { DatePickerABX } from '../../../components/pickers/DatePicker'
import { addDaysDate, dateFormatToString, ObtenerFechaActual } from '../../../../utils/utils'
import { BotonProcesar } from '../../../components/buttons/BotonProcesar'
import '../../../../assets/css/GestionOperacional/MatrizOperativa.css'
import { useModal } from '../../../../hooks/useModal'
import { Modal } from '../../../components/modal/Modal'
import ContenedorSeguimiento from '../../Monitoreo/CentroMonitoreo/ContenedorSeguimiento'
import PantallaCargaInterna from '../../../components/forms/PantallaCargaInterna'

const MatrizOperativa = () => {
  const hookMatrizOperativa = useMatrizOperativa()
  const [fechaInicio, setFechaInicio] = useState(addDaysDate(-7))
  const [fechaFin, setFechaFin] = useState(new Date())
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(0)
  const [rutaSeleccionada, setRutaSeleccionada] = useState(0)
  const [nombreEmpresaSeleccionada, setNombreEmpresaSeleccionada] = useState("")
  const [nombreRutaSeleccionada, setNombreRutaSeleccionada] = useState("")
  const [isOpenModalSeguimiento, openModalSeguimiento, closeModalSeguimiento] = useModal()
  const [estaCargando, setEstaCargando] = useState(false)

  useEffect(() => {
    listarTabla()
  },[])

  const listarTabla = async () => {
    setEstaCargando(true)
    await hookMatrizOperativa.listarMatrizOperativa(
      dateFormatToString(fechaInicio),
      dateFormatToString(fechaFin)
    )
    setEstaCargando(false)
  }
  return (
    <>
      {
        estaCargando ? <PantallaCargaInterna></PantallaCargaInterna> : <></>
      }
      <div className='w-full h-full flex flex-col'>
        <ContenedorParametros
          titulo='Matriz operativa'
        >
          <div className='flex gap-2 items-center'>
            <i title='Fecha inicio' className='fas fa-calendar'></i>
            <DatePickerABX date={fechaInicio} setDate={setFechaInicio} maxDate={new Date()}></DatePickerABX>
          </div>
          <div className='flex gap-2 items-center'>
            <i title='Fecha fin' className='fas fa-calendar'></i>
            <DatePickerABX date={fechaFin} setDate={setFechaFin} maxDate={new Date()}></DatePickerABX>
          </div>
          <BotonProcesar onClick={listarTabla}></BotonProcesar>
        </ContenedorParametros>
        <div className='!overflow-auto flex-grow containerScroll relative w-full'>
          <table id='tablaMatrizOperativa' className='table'>
            <thead>
              <tr>
                <th rowSpan={3}>Nº</th>
                <th colSpan={3}>EMPRESA</th>
                <th rowSpan={3}>FLOTA<br/>AUTORIZADA</th>
                {
                  hookMatrizOperativa.filasMatrizOperativa.length != 0
                  ? Object.entries(hookMatrizOperativa.agrupadoPorMesYAnio)
                    .map(([anio, meses], i) => (
                      <th key={i+1} colSpan={Object.values(meses).flat().length} title={anio}>{anio}</th>
                    ))
                  : <th rowSpan={3} className='min-w-[50px]'></th>
                }
                <th colSpan={5}>INDICADORES</th>
                <th rowSpan={3} className='w-[200px]'>SEGUIMIENTO</th>
              </tr>
              <tr>
                <th rowSpan={2}>RUC</th>
                <th rowSpan={2}>RAZÓN SOCIAL</th>
                <th rowSpan={2}>RUTA</th>
                {
                  hookMatrizOperativa.filasMatrizOperativa.length != 0
                  ? Object.entries(hookMatrizOperativa.agrupadoPorMesYAnio)
                    .map(([anio, meses], i) => (
                      Object.entries(meses).map(([mes, dias], j) => (
                        <th ref={(node) => {
                            if (node) {
                                node.style.setProperty("top", "33px", "important");
                            }
                        }} key={`${i+1}_${j+1}`} colSpan={dias.length} title={mes}>{mes}</th>
                      ))
                    )).flat()
                  : <></>
                }
                <th rowSpan={2}>PB</th>
                <th rowSpan={2}>IPK</th>
                <th rowSpan={2}>IPB</th>
                <th rowSpan={2}>PP</th>
                <th rowSpan={2}>IKB</th>
              </tr>
              <tr>
                {
                  hookMatrizOperativa.filasMatrizOperativa.length != 0
                  ? Object.entries(hookMatrizOperativa.agrupadoPorMesYAnio)
                    .map(([anio, meses], i) => (
                      Object.entries(meses).map(([mes, dias], j) => (
                        dias.map((dia,k) => <th ref={(node) => {
                            if (node) {
                                node.style.setProperty("top", "66px", "important");
                            }
                        }} key={`${i+1}_${j+1}_${k+1}`} title={`${dia.dia}/${dia.mesNumero}/${dia.anio}`}>{dia.dia}</th>)
                      )).flat()
                    )).flat()
                  : <></>
                }
              </tr>
            </thead>
            <tbody>
              {
                hookMatrizOperativa.filasMatrizOperativa.length != 0
                ? hookMatrizOperativa.filasMatrizOperativa.map((data,i) => (
                    <tr key={i+1}
                      onClick={() => {
                        setEmpresaSeleccionada(data.codEmpresa)
                        setRutaSeleccionada(data.codRuta)
                        setNombreEmpresaSeleccionada(data.nomEmpresa)
                        setNombreRutaSeleccionada(data.nomRuta)
                      }}
                    >
                      <td className='text-center'>{i+1}</td>
                      <td className='text-center'>{data.ruc}</td>
                      <td title={data.nomEmpresa}>{data.nomEmpresa}</td>
                      <td className='text-center'>{data.nomRuta}</td>
                      <td className='text-center'>{data.flotaAutorizada}</td>
                      {
                        data.fechasReportes.map((data2,j) => <td key={`${i+1}_${j+1}`} className='text-center' >{data2.valor}</td>)
                      }
                      <td className='text-center' title={Number(data.pb).toFixed(2)} >{Number(data.pb).toFixed(2)}</td>
                      <td className='text-center' title={Number(data.ipk).toFixed(2)} >{Number(data.ipk).toFixed(2)}</td>
                      <td className='text-center' title={Number(data.ipb).toFixed(2)} >{Number(data.ipb).toFixed(2)}</td>
                      <td className='text-center' title={Number(data.pp).toFixed(2)} >{Number(data.pp).toFixed(2)}</td>
                      <td className='text-center' title={Number(data.ikb).toFixed(2)} >{Number(data.ikb).toFixed(2)}</td>
                      <td>
                        <div onClick={openModalSeguimiento} className='max-w-[200px] overflow-auto containerScroll flex'>
                          {
                            data.cantidadSeguimiento != 0
                            ? Array.from({length: data.cantidadSeguimiento})
                              .map((_,i) => (
                                <div 
                                  key={i+1} 
                                  onClick={openModalSeguimiento} 
                                  className='content-center text-center w-[20px] h-[20px] flex-shrink-0 rounded-[4px] border border-gray-400 bg-blue-600 text-xs'
                                >{i+1}</div>
                              ))
                            : <div 
                                onClick={openModalSeguimiento} 
                                className='content-center text-center w-[20px] h-[20px] flex-shrink-0 rounded-[4px] border border-gray-400 bg-green-600 text-xs'
                              ><i className='fas fa-plus'></i></div>
                          }
                        </div>
                      </td>
                    </tr>
                  ))
                : <tr><td colSpan={12} className='text-center'>No hay información con los parametros seleccionados...</td></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      
      <Modal
        title={`Seguimiento Empresa: [${nombreEmpresaSeleccionada}] - Ruta: [${nombreRutaSeleccionada}]`}
        isOpen={isOpenModalSeguimiento}
        closeModal={() => {
          closeModalSeguimiento()
        }}
        validButton={{denied: true, confirm: false}}
        textButtons={{denied: 'Cerrar'}}
      >
        {
          isOpenModalSeguimiento
          ? <ContenedorSeguimiento
              fechaInicio={dateFormatToString(fechaInicio)}
              fechaFin={dateFormatToString(fechaFin)}
              key={`${empresaSeleccionada}_${rutaSeleccionada}`}
              codEmpresa={empresaSeleccionada}
              codRuta={rutaSeleccionada}
            />
          : <></>
        }
      </Modal>
    </>
  )
}

export default MatrizOperativa